import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false,
  ...props
}: CardProps) {
  return <div className={`
        bg-ivory-200 rounded-xl border border-beige/60 shadow-sm overflow-hidden
        ${hover ? 'transition-all duration-300 hover:shadow-md hover:-translate-y-1' : ''}
        ${className}
      `} {...props} data-id="element-467">
      {children}
    </div>;
}